module.exports = __webpack_public_path__ + "media/frontend/assets/icons/icon-resign-25cc0128390d963e25de8d2fa3ab79ee.png";